import React from 'react'
import translate from 'core/translate'
import { useTemplateEditorContext } from '../hooks/templateEditorContext'
import { TemplateEditorInspectorCanvasSettings } from './templateEditor__inspectorCanvasSettings'
import { TemplateEditorInspectorElementSettings } from './templateEditor__inspectorElementSettings'
import styles from './templateEditor__inspector.jcss'

export const TemplateEditorInspector = () => {
    const { selectedElement } = useTemplateEditorContext()

    return (
        <aside className={styles.inspector} id="inspector">
            <div className={styles.title} id="inspector-title">
                {selectedElement ? translate('templateEditorShape') : translate('templateEditorInspector')}
            </div>
            <div className={styles.body} id="inspector-body">
                {selectedElement ? (
                    <TemplateEditorInspectorElementSettings element={selectedElement} />
                ) : (
                    <TemplateEditorInspectorCanvasSettings />
                )}
            </div>
        </aside>
    )
}
